export enum WORKFLOW_VIEW_POPUP_STATE {
  INTRO = "INTRO",
  VIEW_NAMING = "VIEW_NAMING",
  APPLY_FILTERS = "APPLY_FILTERS",
  CONFIGURE_CARD = "CONFIGURE_CARD",
  CONFIRM_FILTERS = "CONFIRM_FILTERS",
  EDIT_FILTERS = "EDIT_FILTERS",
  VIEW_QUEUES = "VIEW_QUEUES",
}

export enum FILTER_SELECT_TYPE {
  SINGLE = "single",
  MULTI = "multi",
}
export enum FILTER_VALUE_TYPE {
  CUSTOM = "custom",
  PEOPLE = "people",
}

export enum WORKFLOW_ACTION_TYPE {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum VIEW_FILTERS {
  TAGS = "TAGS",
  APPOINTMENT_CHANNEL = "APPOINTMENT_CHANNEL",
  APPOINTMENT_MODE = "APPOINTMENT_MODE",
  APPOINTMENT_STATUS = "APPOINTMENT_STATUS",
  PAYMENT_STATUS = "PAYMENT_STATUS",
  SERVICES = "SERVICES",
  DOCTOR = "DOCTOR",
  LABELS = "LABELS",
  SELF_ASSESSMENTS = "SELF_ASSESSMENTS",
}

export enum QUEUE_CARD_ACTIONS {
  TAGS = "TAGS",
  VISIT_TYPE = "VITY",
  PAYMENT_STATUS = "PAYS",
  ASSESSMENT_STATUS = "ASST",
  PAST_VISITS = "PRES",
  CREATE_ABHA = "ABHA",
  ADD_VITALS_AND_LAB_RESULTS = "AVLR",
  ADD_ADDRESS = "ADDR",
  REQUEST_RECORDS = "RMDR",
  REQUEST_PAYMENT = "REQP",
  ARCHIVE_APPOINTMENT = "AAPT",
  CREATE_CERTIFICATE = "CRMC",
  REFER_TO_DOCTOR = "RTOD",
  SEND_GOOGLE_REVIEW_LINK = "SGRL",
  MARK_NO_SHOW = "MNSH",
  CREATE_TEMPLATE = "CATP",
  FOLLOW_UP = "FLWU",
  ABHA_ID = "ABHA_ID",
  UPLOAD_MEDICAL_RECORDS = "UPMR",
  RESUME = "RESUME",
  CHECK_IN = "CHECK_IN",
  EXIT = "EXIT",
  WRITE_RX = "WRITE_RX",
  START_VISIT = "START_VISIT",
  RECEIPT = "RECEIPT",
  ORDER_MEDICINE = "ORDER_MEDICINE",
  PRINT_RX = "PRINT_RX",
  QUESTIONAIRE = "SAQU",
  LABEL = "LABEL",
  NOTES = "NOTES",
  ASSIGN_DOCTOR = "ASSIGN_DOCTOR",
  RESCHEDULE_APPOINTMENT = "RAPT",
  ADD_SERVICES_TO_APPOINTMENT = "ASTA",
  UPDATE_APPOINTMENT_PAYMENT_STATUS = "UAPS",
}
